<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { LOCALES, LOCALE_NAMES, setLocale, type Locale } from '@/i18n';
import { useAuth } from '@/stores/auth';

const { t, locale } = useI18n();
const auth = useAuth();
const router = useRouter();
const route = useRoute();

function changeLocale(e: Event) {
  setLocale((e.target as HTMLSelectElement).value as Locale);
}
async function logout() {
  await auth.logout();
  await router.push({ name: 'home' });
}
function roleKey(r: string | null): string {
  return r === 'institution_admin' ? 'admin' : (r ?? 'student');
}
</script>

<template>
  <header v-if="!route.meta.fullscreen" class="topbar">
    <router-link to="/" class="brand">
      <span class="logo">⚗</span>
      <span>{{ t('app.name') }}</span>
      <small>{{ t('app.tagline') }}</small>
    </router-link>
    <nav class="nav">
      <router-link v-if="auth.isStudent" to="/">{{ t('nav.assignments') }}</router-link>
      <router-link v-if="auth.isTeacher || auth.isAdmin" to="/teacher">{{
        t('nav.assignments')
      }}</router-link>
      <router-link v-if="auth.role === 'superadmin'" to="/superadmin">{{ t('nav.superadmin') }}</router-link>
      <router-link v-if="auth.isAdmin" to="/admin">{{ t('nav.admin') }}</router-link>
      <router-link to="/demo">{{ t('app.demo') }}</router-link>
      <router-link to="/chemical/new">{{ t('nav.chemlab') }}</router-link>
    </nav>
    <div class="right">
      <select class="locale" :value="locale" @change="changeLocale" :aria-label="t('app.language')">
        <option v-for="l in LOCALES" :key="l" :value="l">{{ LOCALE_NAMES[l] }}</option>
      </select>
      <template v-if="auth.isAuthenticated">
        <span class="user">{{ auth.user?.name }} · {{ t('app.' + roleKey(auth.role)) }}</span>
        <button class="btn ghost sm" @click="logout">{{ t('app.logout') }}</button>
      </template>
      <router-link v-else to="/login" class="btn sm">{{ t('app.login') }}</router-link>
    </div>
  </header>
  <main :class="route.meta.fullscreen ? 'full' : 'page'">
    <router-view />
  </main>
</template>
